import { connect } from "react-redux";
import SearchBar from "components/organisms/SearchBar";
import {
  queryChange,
  filterMounted,
  formSubmit,
  suggestionsRequest,
} from "actions";
import config from "config";
import * as filterUtils from "utils/filter";
import { deepMerge } from "utils/object";

const mapStateToProps = (state, ownProps) => {
  const filterName = filterUtils.getQueryFilterName();
  const placeholder =
    ownProps.textFilter && ownProps.textFilter.placeholder
      ? ownProps.textFilter.placeholder
      : state.filters[filterName].label;

  return {
    actionUrl: config.baseurl,
    suggestions: state.suggestions,
    textFilter: {
      name: filterName,
      placeholder,
      value:
        state.filters[filterName].values &&
        state.filters[filterName].values.length > 0
          ? state.filters[filterName].values[0]
          : "",
    },
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onQueryChange: (name, value, valueBeforeSuggest) => {
      dispatch(queryChange(name, value, valueBeforeSuggest));
    },
    onFormSubmit: (value, formNode) => {
      dispatch(formSubmit(value, formNode));
    },
    onSuggestionsRequest: (term) => {
      dispatch(suggestionsRequest(term));
    },
    textFilter: {
      onMountStateChange: (name, mounted) => {
        dispatch(filterMounted(name, mounted));
      },
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return deepMerge({}, ownProps, stateProps, dispatchProps);
};

const SearchBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SearchBar);

export default SearchBarContainer;
